import React, { useState } from "react"
import { Box, Typography, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button } from "@mui/material"
import { AddCircleRounded, DeleteOutline, Edit, RemoveRedEyeOutlined } from "@mui/icons-material"
import style from "./style"
import color from "../../../constants/color"
import { useNavigate, useLocation } from "react-router-dom"
import Modal from "../../../components/Modal"


const CompanyList = ({ companyList, handleDeleteCompany, opens, setOpens }) => {
  const navigate = useNavigate()
  const location = useLocation();
  const role = localStorage.getItem("role");
  const [from, setFrom] = useState("");
  const permission = JSON.parse(localStorage.getItem("permission") || "{}");
  const [deleteId, setDeleteId] = useState();


  const handleEdit = (id) => {
    navigate("/dashboard/accountSettings", { state: { id, isEditable: true } })
  }

  const handleView = (id) => {
    navigate("/dashboard/accountSettings", { state: { id, isEditable: false } })
  }
  const handleNavigateBack = () => {
    setFrom("")
    navigate("/dashboard/accountSettings", { state: { from: "New" } })

  }

  const handleDelete = (item) => {
    setDeleteId(item)
  }

  return (
    <>
      <Grid container>
        <Grid sx={style.mainBox}>
          <Box >
            <Typography variant="body1" sx={style.mainHeading}>
              Company List
            </Typography>
          </Box>
          {(location.pathname === "/dashboard/companyList" || location.pathname === "/dashboard/profile") &&
            role === "Admin" &&
            (from === "" || permission?.account?.isEdit) && (
            <Button variant="contained" type="submit" color="success" sx={style.addButtons} onClick={() => handleNavigateBack()}>
            <AddCircleRounded sx={{ marginRight: "5px" }} />
            Add New Company
            </Button>
          )}
        </Grid>

        <Grid container>
          <Grid item xs={12} sx={{ ...style.gridbioBoxs, }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={style.TableHead}>Company Name</TableCell>
                    <TableCell sx={style.TableHead}>Action</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {companyList?.map((item, index) => (
                    <TableRow key={index}>

                      <TableCell >
                        <Typography sx={style.name}>{item?.companyName}</Typography>     </TableCell>
                      <TableCell >
                        <Edit sx={{ color: color.lightText, mx: 1, }} onClick={() => handleEdit(item?._id)} />
                        <RemoveRedEyeOutlined
                          onClick={() => handleView(item?._id)}
                          sx={style.viewIcon}
                        />
                        <DeleteOutline sx={{ color: "red" }} onClick={() => { handleDelete(item?._id); setOpens(true) }} />
                      </TableCell>
                    </TableRow>
                  ))}

                </TableBody>
              </Table>
              <Modal open={opens} setOpen={setOpens} deletetText={"Delete"} cancelText={"Cancel"} title={"WARNING"} handleDelete={() => handleDeleteCompany(deleteId)}>
                <Box>
                  <Typography>Are you sure you want to Delete Company Permanently? Once deleted, all associated data will be permanently removed and cannot be recovered. </Typography>
                </Box>
              </Modal>

            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default CompanyList
